import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=39404e47"
import script from "./radio.vue?vue&type=script&lang=ts"
export * from "./radio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports